import { cn } from "../../../lib/utils";
import { MaxWidthType, getMaxWidthClass, is90vwWidth } from "./styleUtils";

/**
 * Generate Mantine Modal classNames object
 */
export function getModalClassNames(
  maxWidth: MaxWidthType = "2xl",
  className: string = ""
): {
  content: string;
  header: string;
} {
  const maxWidthClass = getMaxWidthClass(maxWidth);
  const is90vw = is90vwWidth(maxWidth);

  return {
    content: cn(
      is90vw ? "flex flex-col overflow-hidden" : "max-h-[90vh] overflow-hidden flex flex-col",
      "bg-background text-foreground border border-border",
      "shadow-xl rounded-lg",
      "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
      maxWidthClass,
      className
    ),
    header: cn(
      "flex items-center justify-between gap-4"
    ),
  };
}

/**
 * Generate header classNames with optional headerContent padding
 */
export function getHeaderClassNames(hasHeaderContent: boolean): string {
  return cn(
    "flex items-center justify-between gap-4",
    hasHeaderContent && "pr-2"
  );
}

/**
 * Generate Mantine Modal registration props for global modal stack
 */
export function getModalStackProps(
  useGlobalStack: boolean,
  globalModalId: string | undefined,
  globalModalStack: any
): Record<string, any> {
  if (!useGlobalStack || !globalModalId || !globalModalStack) {
    return {};
  }

  return globalModalStack.modalStack.register(globalModalId);
}
